import React from "react";
import { useAuth } from "../context/AuthContext";
import { Link, Navigate } from "react-router-dom";
import { DEVLOG, MEDIA, PILLARS, PITCH, STEAM_URL, TAGLINE } from "./content";
import "./showcase.css";

// The public front door of dowtex. Sits outside AuthenticatedLayout (like the share page), so a
// visitor with no account sees the game, not a redirect to /login.

const SteamButton: React.FC = () =>
    STEAM_URL ? (
        <a className="mf-btn mf-btn--primary" href={STEAM_URL} target="_blank" rel="noreferrer">
            Wishlist on Steam
        </a>
    ) : (
        <span className="mf-btn mf-btn--primary mf-btn--disabled">
            Steam page coming soon
        </span>
    );

const ShowcasePage: React.FC = () => {
    const { isAuthenticated, isLoading } = useAuth();
    if (isLoading) return null;
    if (isAuthenticated) return <Navigate to="/dashboard" replace />;
    return (
    <div className="mf">
        <a className="mf-skip" href="#main">Skip to content</a>
        <header className="mf-wrap mf-nav">
            <span className="mf-logo">Misfits</span>
            <Link className="mf-btn" to="/dashboard">Sign in to dowtex</Link>
        </header>

        <main id="main" className="mf-wrap">
            <section className="mf-hero" aria-labelledby="mf-title">
                <h1 id="mf-title">Misfits</h1>
                <p className="tag">{TAGLINE}</p>
                <div className="mf-cta"><SteamButton /></div>
                <p className="mf-note">Solo or 2–4 player local co-op</p>
            </section>

            <section aria-labelledby="mf-about">
                <h2 id="mf-about" style={{ textAlign: "center" }}>The toys fight back</h2>
                <p className="mf-pitch">{PITCH}</p>
            </section>

            <section aria-label="Pillars">
                <div className="mf-grid">
                    {PILLARS.map(p => (
                        <div className="mf-card" key={p.title}>
                            <h3>{p.title}</h3>
                            <p>{p.body}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section aria-labelledby="mf-media">
                <h2 id="mf-media">Screenshots</h2>
                <div className="mf-grid">
                    {MEDIA.length === 0 ? (
                        <div className="mf-shot mf-shot--empty">Screenshots and clips are on the way.</div>
                    ) : (
                        MEDIA.map(m => (
                            <div className="mf-shot" key={m.src}>
                                {m.kind === "video"
                                    ? <video src={m.src} controls muted playsInline preload="metadata" poster={m.poster} aria-label={m.alt} />
                                    : <img src={m.src} alt={m.alt} loading="lazy" />}
                            </div>
                        ))
                    )}
                </div>
            </section>

            <section aria-labelledby="mf-devlog">
                <h2 id="mf-devlog">Devlog</h2>
                <ol className="mf-log">
                    {DEVLOG.map(e => (
                        <li key={e.date + e.title}>
                            <time dateTime={e.date}>{e.date}</time>
                            <h3>{e.title}</h3>
                            <ul>{e.points.map(pt => <li key={pt}>{pt}</li>)}</ul>
                        </li>
                    ))}
                </ol>
            </section>
        </main>

        <footer className="mf-wrap mf-foot">Misfits is made by one person. dowtex also hosts a few small private tools.</footer>
    </div>
    );
};

export default ShowcasePage;
